(() => {
  'use strict';

  const shell = document.querySelector('.property-listings-shell.pl-detail[data-listing-id]');
  if (!shell || shell.querySelector('[data-pl-same-property]')) {
    return;
  }

  const listingId = Number.parseInt(shell.dataset.listingId || '', 10);
  if (!Number.isInteger(listingId) || listingId <= 0) {
    return;
  }

  const endpoint = `/rcn/property-listing-same-property?id=${encodeURIComponent(String(listingId))}`;

  fetch(endpoint, {
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
    .then((response) => response.ok ? response.text() : '')
    .then((html) => {
      if (typeof html !== 'string' || html.trim() === '') {
        return;
      }

      const template = document.createElement('template');
      template.innerHTML = html.trim();
      const section = template.content.firstElementChild;
      if (!(section instanceof HTMLElement) || !section.matches('[data-pl-same-property]')) {
        return;
      }

      // The comparison goes right before „Podobne ogłoszenia w okolicy”
      // (`data-pl-similar`), or before the report form when there are no
      // similar listings (`data-pl-report`).
      const similarSection = shell.querySelector('[data-pl-similar]');
      const reportSection = shell.querySelector('[data-pl-report]');
      const insertionPoint = similarSection || reportSection;

      if (insertionPoint) {
        insertionPoint.before(section);
      } else {
        shell.append(section);
      }
    })
    .catch(() => {
      // Progressive enhancement: a comparison failure must not break detail.
    });
})();
